import { FC } from 'react';
import { styled } from '../../../../../packages/theme/stitches.config';
import { GenericLayout } from '../../../../constants/generic';

export const Field: FC<{ mode: GenericLayout; lineColor?: string }> = ({ mode, lineColor = 'white' }) => {
  if (mode === GenericLayout.HORIZONTAL) {
    return (
      <svg width='756' height='402' viewBox='0 0 756 402' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g opacity='0.5'>
          <path d='M755 101L675 101L675 301L755 301' stroke={lineColor} strokeWidth='2' />
          <path d='M755 161L715 161L715 241L755 241' stroke={lineColor} strokeWidth='2' />
          <path d='M674.999 168.523C655.999 174.73 634.499 211.19 674.999 232.523' stroke={lineColor} strokeWidth='2' />
          <path d='M1 301L81 301L81 101L0.999991 101' stroke={lineColor} strokeWidth='2' />
          <path d='M1 241L41 241L41 161L0.999997 161' stroke={lineColor} strokeWidth='2' />
          <path d='M81 232.977C100 226.771 121.5 190.31 81 168.977' stroke={lineColor} strokeWidth='2' />
          <path
            d='M378 142C410.585 142 437 168.415 437 201C437 233.585 410.585 260 378 260C345.415 260 319 233.585 319 201C319 168.415 345.415 142 378 142Z'
            stroke={lineColor}
            strokeWidth='2'
          />
          <rect x='377' y='401' width='400' height='2.00002' rx='1.00001' transform='rotate(-90 377 401)' fill={lineColor} />
          <circle cx='378' cy='201' r='4' transform='rotate(-90 378 201)' fill={lineColor} />
          <rect x='1' y='1' width='754' height='400' rx='8' stroke={lineColor} strokeWidth='2' />
          <path d='M14 400C14 393.373 8.62742 388 2 388' stroke={lineColor} strokeWidth='2' />
          <path d='M2 14C8.62742 14 14 8.62742 14 2' stroke={lineColor} strokeWidth='2' />
          <path d='M742 2C742 8.62742 747.373 14 754 14' stroke={lineColor} strokeWidth='2' />
          <path d='M754 388C747.373 388 742 393.373 742 400' stroke={lineColor} strokeWidth='2' />
        </g>
      </svg>
    );
  }

  if (mode === GenericLayout.VERTICAL) {
    return (
      <svg width='332' height='601' viewBox='0 0 332 601' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g opacity='0.5'>
          <path d='M255.5 600.231L255.5 520.231L75.5 520.231L75.5 600.231' stroke={lineColor} strokeWidth='2' />
          <path d='M205 600L205 570L125 570L125 600' stroke={lineColor} strokeWidth='2' />
          <path d='M196 520C190.182 503.477 156 484.781 136 520' stroke={lineColor} strokeWidth='2' />
          <path d='M75.5 1.9996L75.5 81.9996L255.5 81.9996L255.5 1.99957' stroke={lineColor} strokeWidth='2' />
          <path d='M126 2.23129L126 32.2313L206 32.2313L206 2.23128' stroke={lineColor} strokeWidth='2' />
          <path d='M135 82.2313C140.818 98.7536 175 117.45 195 82.2313' stroke={lineColor} strokeWidth='2' />
          <path
            d='M215 302.231C215 329.293 193.062 351.231 166 351.231C138.938 351.231 117 329.293 117 302.231C117 275.169 138.938 253.231 166 253.231C193.062 253.231 215 275.169 215 302.231Z'
            stroke={lineColor}
            strokeWidth='2'
          />
          <rect x='2' y='300' width='328' height='2.00002' fill={lineColor} />
          <circle cx='166' cy='301.151' r='4' fill={lineColor} />
          <rect x='331' y='1' width='598.769' height='330' rx='4' transform='rotate(90 331 1)' stroke={lineColor} strokeWidth='2' />
          <path d='M13 598.769C13 592.144 7.62742 586.774 0.999999 586.774' stroke={lineColor} strokeWidth='2' />
          <path d='M330 586.774C323.373 586.774 318 592.144 318 598.769' stroke={lineColor} strokeWidth='2' />
          <path d='M318 1.99963C318 8.62449 323.373 13.995 330 13.995' stroke={lineColor} strokeWidth='2' />
          <path d='M1 13.995C7.62742 13.995 13 8.62449 13 1.99963' stroke={lineColor} strokeWidth='2' />
        </g>
      </svg>
    );
  }

  if (mode === GenericLayout.VERTICAL_CONDENSED) {
    return (
      <svg width='294' height='601' viewBox='0 0 294 601' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g opacity='0.5'>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M237.5 600.228L235.5 600.228L235.5 521.228L57.5 521.228L57.5 600.228L55.5 600.228L55.5 519.228L237.5 519.228L237.5 600.228Z'
            fill={lineColor}
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M187 599.996L185 599.996L185 570.996L107 570.996L107 599.996L105 599.996L105 568.996L187 568.996L187 599.996Z'
            fill={lineColor}
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M168.614 507.298C173.053 510.908 176.413 515.318 177.943 519.664L176.057 520.329C174.678 516.414 171.583 512.291 167.352 508.849C163.129 505.414 157.833 502.708 152.124 501.574C146.424 500.443 140.318 500.879 134.428 503.716C128.537 506.553 122.789 511.827 117.87 520.49L116.131 519.503C121.211 510.557 127.236 504.96 133.561 501.914C139.887 498.867 146.44 498.407 152.513 499.613C158.577 500.816 164.167 503.681 168.614 507.298Z'
            fill={lineColor}
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M147 349.228C173.51 349.228 195 327.738 195 301.228C195 274.718 173.51 253.228 147 253.228C120.49 253.228 99 274.718 99 301.228C99 327.738 120.49 349.228 147 349.228ZM147 351.228C174.614 351.228 197 328.842 197 301.228C197 273.614 174.614 251.228 147 251.228C119.386 251.228 97 273.614 97 301.228C97 328.842 119.386 351.228 147 351.228Z'
            fill={lineColor}
          />
          <path d='M1 299.068L293 299.068L293 301.015L1 301.015L1 299.068Z' fill={lineColor} />
          <path
            d='M151 300.148C151 302.357 149.209 304.148 147 304.148C144.791 304.148 143 302.357 143 300.148C143 297.939 144.791 296.148 147 296.148C149.209 296.148 151 297.939 151 300.148Z'
            fill={lineColor}
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M55.5 -0.00366211L57.5 -0.00366246L57.5 78.9963L235.5 78.9963L235.5 -0.00369358L237.5 -0.00369393L237.5 80.9963L55.5 80.9963L55.5 -0.00366211Z'
            fill={lineColor}
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M106 0.228012L108 0.228012L108 29.228L186 29.228L186 0.227998L188 0.227998L188 31.228L106 31.228L106 0.228012Z'
            fill={lineColor}
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M124.386 92.9268C119.947 89.3163 116.587 84.9066 115.057 80.5602L116.943 79.8959C118.322 83.8106 121.417 87.9338 125.648 91.3752C129.871 94.81 135.167 97.5167 140.876 98.65C146.576 99.7815 152.682 99.345 158.572 96.5084C164.463 93.6712 170.211 88.3975 175.13 79.7342L176.869 80.7218C171.789 89.6678 165.764 95.2641 159.439 98.3103C153.113 101.357 146.56 101.817 140.487 100.612C134.423 99.408 128.833 96.5438 124.386 92.9268Z'
            fill={lineColor}
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M289 5.96244e-08C291.761 2.66948e-08 294 2.23485 294 4.99168L294 595.008C294 597.765 291.761 600 289 600L5.00001 600C2.23859 600 7.12828e-06 597.765 7.0954e-06 595.008L5.95252e-08 4.99169C2.66505e-08 2.23486 2.23859 3.47922e-06 5 3.44629e-06L289 5.96244e-08ZM292 4.99168C292 3.33758 290.657 1.99667 289 1.99667L5 1.99667C3.34314 1.99667 2 3.33759 2 4.99169L2.00001 595.008C2.00001 596.662 3.34315 598.003 5.00001 598.003L289 598.003C290.657 598.003 292 596.662 292 595.008L292 4.99168Z'
            fill={lineColor}
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M2 586.795C8.0755 586.795 13 591.71 13 597.772L15 597.772C15 590.607 9.17934 584.799 2 584.799L2 586.795Z'
            fill={lineColor}
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M281 597.772C281 591.71 285.925 586.795 292 586.795L292 584.799C284.821 584.799 279 590.607 279 597.772L281 597.772Z'
            fill={lineColor}
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M292 12.9734C285.925 12.9734 281 8.0584 281 1.9963L279 1.9963C279 9.16186 284.821 14.97 292 14.97L292 12.9734Z'
            fill={lineColor}
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M13 1.99629C13 8.0584 8.0755 12.9734 2 12.9734L2 14.97C9.17934 14.97 15 9.16186 15 1.99629L13 1.99629Z'
            fill={lineColor}
          />
        </g>
      </svg>
    );
  }

  return null;
};

const Svg = styled.withConfig({ componentId: 'Field', displayName: 'Svg' })('svg', {
  width: '100%',
});

const Rect = styled.withConfig({ componentId: 'Field', displayName: 'Rect' })('rect', {
  variants: {
    withFill: {
      true: {
        fill: '$footballFieldTone',
      },
      false: {},
    },
    withStroke: {
      true: {
        stroke: '$footballFieldTone',
      },
      false: {},
    },
  },
});

export default Field;
